import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import { ExperienceTracker } from '@gonfalon/analytics/ExperienceTracker';
import { isExampleResource } from '@gonfalon/analytics/isExampleResource';
import type { AnalyticEventData } from '@gonfalon/analytics/types';

import type { MetricsEventName } from './types';

const baseTrackMetricsEvent = createTrackerForCategory('Metrics');

export const trackMetricsEvent = (event: MetricsEventName, data?: AnalyticEventData) => {
  baseTrackMetricsEvent(event, data);
};

export const trackMetricViewed = (metricKey?: string) => {
  const attrs = metricKey ? { isExampleResource: isExampleResource(metricKey) } : undefined;

  trackMetricsEvent('Metric Viewed', attrs);
};

export const trackMetricDashboardViewed = () => {
  trackMetricsEvent('Metric Dashboard Viewed');
};

const metricsEventAttributes = {
  owners: ['team-metrics'],
  category: 'Metrics',
} satisfies Parameters<typeof ExperienceTracker.create>[1];

export type MDSEditorEvent =
  | 'Toggle Accordion'
  | { eventName: 'Preview SQL Submitted'; attributes: { valid: boolean } }
  | 'Preview SQL Success'
  | { eventName: 'Preview SQL Error'; attributes: { sqlQuery: string } }
  | 'Form Submission';

export const createMDSTracker = ExperienceTracker.create<MDSEditorEvent>(
  'Create Metric Data Source',
  metricsEventAttributes,
);

export const updateMDSTracker = ExperienceTracker.create<MDSEditorEvent>(
  'Update Metric Data Source',
  metricsEventAttributes,
);

export const listMDSTracker = ExperienceTracker.create<
  | 'Click Create CTA'
  | 'Filter Applied'
  | 'Clicked Edit'
  | 'Copy'
  | 'Archive Start'
  | 'Archive Success'
  | 'Archive Error'
  | 'Clicked Data Source Link'
>('View Metric Data Source List', metricsEventAttributes);

export const viewMDSTracker = ExperienceTracker.create<
  | 'Quick Edit Start'
  | 'Quick Edit Success'
  | 'Quick Edit Error'
  | { eventName: 'Clicked Create Metric'; attributes: { metricsCount: number | undefined } }
>('View Metric Data Source', metricsEventAttributes);

export const metricsSearchTracker = ExperienceTracker.create<
  | {
      eventName: 'Category Selected';
      attributes: { categoryName: string };
    }
  | {
      eventName: 'Item Selected';
      attributes: {
        itemType: 'metricGroup' | 'metric';
        itemKey: string;
        categoryName: string;
        searchQuery: string;
      };
    }
  | { eventName: 'Search Queried'; attributes: { searchQuery: string } }
  | 'Clicked Create Button'
  | 'Unselect All Clicked'
  | { eventName: 'Link to Full Resource Clicked'; attributes: { kind: 'metric' | 'metricGroup' } }
>('Metrics Search', metricsEventAttributes);
